/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { Modal, Form } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import FileSaver from 'file-saver';
import WithRouter from '../Extensions/WithRouter';
//import { convertPropertiesToCamelCase } from '../../utils/shared';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import {
  SPDX_EXTENSION_JSON,
  SPDX_EXTENSION_XML,
} from '../../constants/reports';
import './CBOMGenerator.css';

class CBOMGenerator extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.state = {
      isOpenMCB: props.isOpenMCB,
      isDownloadLoading: false,
      isLoading: false,
      isOpenWarnModal: false,
      fileName: '',
      modalValue: '',
      exportFormat: SPDX_EXTENSION_JSON,
      fileNameError: false,
    };
    this.handleExportFormat = this.handleExportFormat.bind(this);
    this.handleComponentNameChange = this.handleComponentNameChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.createCBOMDownload = this.createCBOMDownload.bind(this);
    this.runWithModalValue = this.runWithModalValue.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMCB, fileName } = this.props;
    if (prevProps.isOpenMCB !== isOpenMCB) {
      this.setState({
        isOpenMCB,
        modalValue: '',
        isOpenWarnModal: false,
        fileName,
        fileNameError: false,
        exportFormat: SPDX_EXTENSION_JSON,
      }, () => {
        if (isOpenMCB) {
          this.getCBOMInfo();
        }
      });
    }
  }

  handleExportFormat(e) {
    this.setState({
      exportFormat: e.target.value,
    });
  }

  handleComponentNameChange(e) {
    this.setState({
      fileName: e.target.value,
      fileNameError: false,
    });
  }

  onSubmit() {
    const { translate } = this.props;

    if (!this.validateForm()) {
      return;
    }

    this.modalHeader = translate('modal.title.notice');
    this.modalBody = translate('modal.message.create_document');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'create',
    });
  }

  validateForm = () => {
    const {
      fileName,
    } = this.state;

    const validation = {
      fileName: true,
    };

    if (fileName.trim().length === 0) {
      this.setState({
        fileNameError: true,
      });
      validation.fileName = false;
      this.fileName.focus();
      this.fileName.scrollIntoView();
      return false;
    }

    return validation.fileName;
  };

  getCBOMInfo = () => {
    const { reportId } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getCBOMInfo(reportId)
        .then(() => {
          this.setState({
            isLoading: false,
          });

        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  createCBOMDownload = () => {
    const { reportId, closeModal, state } = this.props;
    const {
      exportFormat,
      fileName,
      isDownloadLoading
    } = this.state;

    const obj = {
      export_format: exportFormat,
    };

    if (state.user.currentPrecisionLevel) {
      obj.precision_level = state.user.currentPrecisionLevel;
    }

    const file_name = `cbom.clarity-${fileName}.${exportFormat}`;

    if (isDownloadLoading) {
      api
        .createCBOMDownload(reportId, obj)
        .then((res) => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          FileSaver.saveAs(blob, file_name);

          this.setState({
            isDownloadLoading: false,
          });
          closeModal();
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isDownloadLoading: false,
          });
        });
    }
  };

  runWithModalValue() {
    const { closeModal } = this.props;
    const { modalValue } = this.state;

    if (modalValue.indexOf('create') > -1) {
      this.setState({
        isOpenWarnModal: false,
        isDownloadLoading: true,
      }, () => {
        this.createCBOMDownload();
      });
    } else {
      closeModal();
    }
  }

  closeModal(e) {
    const { translate } = this.props;
    if (e.target.classList[0] === 'right_button') {
      return null;
    }

    this.modalHeader = translate('modal.title.attention');
    this.modalBody = translate('modal.message.create_document_cancel');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'MVX',
    });
  }

  closeWarnModal() {
    this.setState({
      isOpenWarnModal: false,
    });
  }

  render() {
    const { translate } = this.props;
    const {
      isOpenWarnModal,
      fileName,
      isOpenMCB,
      isLoading,
      isDownloadLoading,
      exportFormat,
      fileNameError,
    } = this.state;

    const getModalContent = () => {
      if (isDownloadLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup vex">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '60%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.prepare_cbom_download')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      if (isLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup vex">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '60%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.loading')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div>
          <div className="setting_popup_wrap">
            <div
              className="setting_popup vex"
            >
              <div className="setting_popup_header">
                <h2 className="popup_name">{translate('modal.title.create_cbom')}</h2>
                <a
                  className="popup_close_button"
                  onKeyUp={this.closeModal}
                  onClick={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <Form>
                <Form.Field style={{ marginTop: '2em' }}>
                  <label>{translate('modal.title.export_format')}</label>
                  <select value={exportFormat} onChange={this.handleExportFormat}>
                    <option value={SPDX_EXTENSION_JSON}>JSON</option>
                    <option value={SPDX_EXTENSION_XML}>XML</option>
                  </select>
                </Form.Field>
                <Form.Field error={fileNameError}>
                  <label
                    ref={(ref) => {
                      this.fileName = ref;
                    }}
                  >
                    {translate('modal.title.component_name_cyclonedx')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </label>
                  <input
                    type="text"
                    placeholder={translate('modal.title.component_name_cyclonedx')}
                    value={fileName}
                    onChange={this.handleComponentNameChange}
                  />
                </Form.Field>
              </Form>
              <div className="setting_popup_button_wrap_flex cbom">
                <a
                  className="button cencel_button"
                  onKeyUp={this.closeModal}
                  onClick={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  onKeyUp={this.closeModal}
                  onClick={this.onSubmit}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
          <Modal open={isOpenWarnModal} onClose={this.closeWarnModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalHeader}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a
                      className="left_button"
                      onKeyUp={this.closeWarnModal}
                      onClick={this.closeWarnModal}
                    >
                      {translate('modal.button.cancel')}
                    </a>
                    <a
                      className="right_button"
                      onKeyUp={this.runWithModalValue}
                      onClick={this.runWithModalValue}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    };
    return (
      <Modal open={isOpenMCB} onClose={this.closeModal} className="create_vex">
        {getModalContent()}
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(CBOMGenerator)));
